'use client';
import React, { useEffect, useRef, useState } from 'react';

interface ChannelBadge {
  name: string;
  color: string;
  textColor: string;
  size: 'sm' | 'md' | 'lg';
}

const channelBadges: ChannelBadge[] = [
  { name: 'ESPN', color: '#cc0000', textColor: '#fff', size: 'lg' },
  { name: 'FOX NEWS', color: '#003366', textColor: '#fff', size: 'md' },
  { name: 'CNN', color: '#cc0000', textColor: '#fff', size: 'md' },
  { name: 'TNT', color: '#0033cc', textColor: '#fff', size: 'sm' },
  { name: 'HGTV', color: '#006633', textColor: '#fff', size: 'sm' },
  { name: 'TBS', color: '#cc6600', textColor: '#fff', size: 'md' },
  { name: 'FX', color: '#000', textColor: '#fff', size: 'sm' },
  { name: 'BRAVO', color: '#cc0066', textColor: '#fff', size: 'sm' },
  { name: 'A&E', color: '#333', textColor: '#fff', size: 'sm' },
  { name: 'FOOD', color: '#ff6600', textColor: '#fff', size: 'sm' },
  { name: 'TLC', color: '#0099cc', textColor: '#fff', size: 'sm' },
  { name: 'USA', color: '#003399', textColor: '#fff', size: 'md' },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="pt-[68px] px-4 sm:px-6 pb-0">
      <div className="max-w-7xl mx-auto">
        <div className="hero-section relative min-h-[480px] flex items-center">
          {/* Left Content */}
          <div
            className={`relative z-10 px-8 sm:px-12 py-12 max-w-lg transition-all duration-700 ${
              visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}
          >
            <h1 className="text-[36px] sm:text-[44px] font-black text-white leading-tight mb-5">
              Stream Digital TV{' '}
              <span className="text-gradient-blue">Your Way</span>
            </h1>
            <p className="text-[17px] text-[#c3c3c3] leading-relaxed mb-7">
              Get the best sports, news, and entertainment with{' '}
              <span className="font-black" style={{ color: '#ffa300' }}>Sling Consonantal Digital</span>{' '}
              — starting at{' '}
              <span className="price-highlight">$4.99</span>
              <span className="text-[#c3c3c3]">/day</span>{' '}or{' '}
              <span className="price-highlight">$19.99</span>
              <span className="text-[#c3c3c3]">/mo.</span>
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="#plans" className="btn-primary">
                See All Plans
              </a>
              <a href="#passes" className="btn-secondary">
                See All Passes
              </a>
            </div>
          </div>

          {/* Right - Channel Badges Visual */}
          <div
            className={`absolute right-0 top-0 bottom-0 w-1/2 hidden md:flex items-center justify-center transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="relative w-full h-full flex items-center justify-center">
              {/* Background glow */}
              <div className="absolute inset-0 bg-gradient-to-l from-[#0085ff]/10 to-transparent rounded-r-2xl" />
              
              {/* Channel grid */}
              <div className="relative grid grid-cols-3 gap-3 p-8">
                {channelBadges.map((ch, i) => (
                  <div
                    key={i}
                    className={`channel-logo font-black text-center ${
                      ch.size === 'lg' ? 'text-lg col-span-1 row-span-1 py-5' :
                      ch.size === 'md' ? 'text-base py-4' : 'text-sm py-3'
                    }`}
                    style={{
                      backgroundColor: ch.color,
                      color: ch.textColor,
                      border: '1px solid rgba(255,255,255,0.15)',
                      animationDelay: `${i * 0.1}s`,
                    }}
                  >
                    {ch.name}
                  </div>
                ))}
                {/* Pass cards */}
                <div className="col-span-1 bg-[#2b2d39] border border-white/10 rounded-lg p-3 text-center">
                  <div className="text-[#00b9ff] font-black text-xs">1, 3, OR 7</div>
                  <div className="text-white font-black text-sm">DAY PASS</div>
                  <div className="text-[#979797] text-xs mt-1">from $4.99</div>
                </div>
                <div className="col-span-1 bg-[#2b2d39] border border-white/10 rounded-lg p-3 text-center">
                  <div className="text-[#ffa300] font-black text-xs">MONTH</div>
                  <div className="text-white font-black text-sm">OR PREPAY</div>
                  <div className="text-[#979797] text-xs mt-1">from $19.99</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
